import type { Theme, TRuleWithTheme } from '@/styles/theme';

export type TextVariant = keyof Theme['typography'];

export const container: TRuleWithTheme<{
    variant?: TextVariant;
    color?: keyof Theme;
    preserveNewLines: boolean;
}> = ({ theme, variant = 'ParagraphNormalRegular', color = theme.colors.black, preserveNewLines }) => ({
    ...theme.typography[variant],
    color: theme.colors[color as keyof typeof theme.colors],
    ...(preserveNewLines && {
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',
    }),
    marginBottom: 0,
});
